// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1b5cb94","554":"12457e01","807":"af624737","865":"cb03bf87","977":"0ada88f0"}[chunkId] + ".chunk.js";
};